<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="14" height="14" rx="7" fill="currentColor" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2999 12.8464V15.1031H12.6999V12.8464H14.9586V11.4464H12.6999V9.1875H11.2999V11.4464H9.04297V12.8464H11.2999Z" />
</svg>
